import { wait } from 'modules-core/utility'
import { createAudioEffect } from './createEffect'
import { createDefaultEffectParams } from '../constants'
import { AudioEffect } from '../types'
import { rampToValueAtTime, setValueCurveAtTime } from '../utility'
import config from 'modules-core/config'

export const createLinearGainEffect = (params: AudioEffect.VolumeEffectParams = {}) => {
	params = Object.assign(createDefaultEffectParams('volume'), params)
	if (params.isDestination)
		params.output = undefined

	const node = new GainNode(config.audioContext, { gain: params.volume })

	const effect: AudioEffect.VolumeEffect = {
		params,
		...createAudioEffect(node),
		get value() { return node.gain.value },
		set value(val) {
			node.gain.cancelScheduledValues(config.audioContext.currentTime)
			node.gain.value = val
		},
		fadeToValue: async (
			val,
			durationSecs = params.fadeDuration,
			curveName,
			startTime = config.audioContext.currentTime,
		) => {
			rampToValueAtTime(
				node.gain,
				val,
				startTime,
				durationSecs,
				curveName,
			)
			await wait(durationSecs * 1000)
		},
		fadeToValueCurve: async (
			values,
			durationSecs = params.fadeDuration,
			startTime = config.audioContext.currentTime,
		) => {
			setValueCurveAtTime(node.gain, values, startTime, durationSecs)
			await wait(durationSecs * 1000)
		},
		setParam: {
			'volume': (val) => node.gain.value = val,
			'fadeDuration': val => params.fadeDuration = val
		},
	}
	return effect
}
